module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_key.483f645e.svg";